import React, { Component } from "react";
import { connect } from "react-redux";
import Frame from "../Frame";
import { finishApplication } from "../../actions";
import PropTypes from "prop-types";
class KornerstoneContract extends Component {

  receiveMessage = (event) => {
    const { finishApplication } = this.props
    if (event.data === "kornerstone_completed") {
      finishApplication();
    }
    return;
  }

  render() {
    const { contractUrl, hidden } = this.props
    return (
      <Frame
        hidden={hidden}
        contractUrl={contractUrl}
        onReceiveMessage={this.receiveMessage}
      />
    )
  }
}

KornerstoneContract.propTypes = {
  contractUrl: PropTypes.string
};

KornerstoneContract.defaultProps = {
  contractUrl: ""
};

const mapDistpatchToProps = dispatch => {
  return {
    finishApplication: values => dispatch(finishApplication(values))
  };
};

KornerstoneContract = connect(null, mapDistpatchToProps)(KornerstoneContract);

export default KornerstoneContract;
